import request from '@utils/request';

export function getOrderTrackingApi(params = {}) {
  return request.post('v1/dashboard/order-tracking', params);
}

export function postOrderMetaApi(data = {}) {
  return request.post('v1/dashboard/order-tracking/meta', data);
}